import { DsTextField, type DsTextFieldProps } from '@frontends/ds';
import { type Control, Controller, type FieldPath, type FieldValues } from 'react-hook-form';

type FormTextFieldProps<TFieldValues extends FieldValues> = Omit<
  DsTextFieldProps,
  | 'name'
  | 'value'
  | 'defaultValue'
  | 'onChange'
  | 'onBlur'
  | 'isInvalid'
  | 'errorMessage'
  | 'validationBehavior'
  | 'ref'
> & {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
};

function FormTextField<TFieldValues extends FieldValues>({
  control,
  name,
  ...props
}: FormTextFieldProps<TFieldValues>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <DsTextField
          isFullWidth
          {...props}
          ref={(root) => field.ref(root?.querySelector('input') ?? null)}
          name={field.name}
          value={field.value ?? ''}
          onChange={field.onChange}
          onBlur={field.onBlur}
          validationBehavior="aria"
          isInvalid={fieldState.invalid}
          errorMessage={fieldState.error?.message}
        />
      )}
    />
  );
}

export default FormTextField;
